<template>
  <transition name="no-mode-fade">
    <div
      id="home"
      class="tab-pane fade show active"
      role="tabpanel"
      aria-labelledby="home-tab"
    >
      <div class="row mb-3 mt-3">
        <div class="col-md-3">
          <b-button-group v-if="userType !== 'student'">
            <b-button variant="outline-danger">
              <input
                v-model="selectAll"
                type="checkbox"
                @change="selectItemAll(selectAll)"
              />
            </b-button>
            <b-button
              variant="outline-danger"
              type="button"
              :disabled="recordIds.length == 0"
              @click="multiDelete" v-if=" ['super_admin','distribution'].includes($role)"
            >
              <i class="fa fa-trash" />

              {{ $t("site.bulk_delete") }}
            </b-button>
          </b-button-group>
          <!-- end of form -->
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <input
              v-model="search"
              type="text"
              autofocus
              class="form-control"
              :placeholder="$t(`site.search`)"
              @input="(val) => searchChange(val)"
            />
          </div>
        </div>
        <div class="col-3">
          <div class="float-md-right pt-1">
            <span class="text-muted text-small mr-1 mb-2"
              >{{ from }}:{{ to }}
            </span>

            <b-dropdown
              id="ddown2"
              right
              :text="`${perPage}`"
              variant="outline-warning"
              size="xs"
            >
              <b-dropdown-item
                v-for="(size, index) in [5, 10, 20, 50, 100]"
                :key="index"
                @click="changePageSize(size)"
                >{{ size }}</b-dropdown-item
              >
            </b-dropdown>
            <span class="text-muted mr-1 mb-2"> of {{ total }}</span>
          </div>
        </div>
        <!-- end of col -->
      </div>
      <!-- end of row -->

      <!-- end of row -->

      <div class="row">
        <div class="col-md-12">
          <b-table :stacked="($mobile==1)" 
            ref="table"
            class="vuetable"
            sort-by="id"
            sort-desc.sync="false"
            :current-page="currentPage"
            :fields="bootstrapTable.fields"
            :items="dataProvider"
            striped
            hover
          >
            <template #cell(edit)="data">
              <button
                class="btn btn-icon btn-warning btn-sm"
                @click="editItem(data)"
              >
                <i class="fa fa-edit" />
              </button>
              <button
                type="submit"
                class="btn btn-icon btn-danger btn-sm delete"
                 @click="deleteItem(data)" v-if=" ['super_admin','distribution'].includes($role)"
              >
                <i class="fa fa-trash" />
              </button>
            </template>
            <template #cell(description)="data">
              <div v-html="data.item.description"></div>
            </template>
            <template v-if="userType !== 'student'" #cell(checkbox)="data">
              <label class="kt-checkbox kt-checkbox--single kt-checkbox--solid">
                <input
                  v-model="recordIds"
                  type="checkbox"
                  :value="data.item.id"
                  @change="selectItem(data)"
                />
                <span />
              </label>
            </template>
            <template #cell(image)="data">
              <b-img-lazy
                left
                :src="data.item.image_path"
                blank-src="https://bitsofco.de/content/images/2018/12/broken-1.png"
                center
                rounded="circle"
                style="width: 110px"
              />
            </template>

            <template #cell(image_path)="data">
              <div>
                <b-img :src="data.item.image_path" fluid alt="badge image" />
              </div>
              <!-- <img :src="data.item.image_path" width="50px" height="50px"> -->
            </template>

            <template #cell(assignToStudent)="data">
              <a
                :href="`#/badges/assign-student/${data.item.id}`"
                class="btn btn-primary btn-sm"
                ><i class="fa fa-plus" /> {{ $t("badges.assign_students") }}
              </a>
            </template>
          </b-table>
          <div v-if="load" class="lds-ripple-bk justify-content-center">
            <div />
            <div />
          </div>

          <hr />

          <b-pagination
            v-model="currentPage"
            align="right"
            class="dataTables_paginate paging_simple_numbers pagination-warning"
            :total-rows="totalRows"
            :per-page="perPage"
          >
            <template v-slot:next-text>
              <i class="fas fa-angle-left" />
            </template>
            <template v-slot:prev-text>
              <i class="fas fa-angle-right" />
            </template>
            <template v-slot:first-text>
              <i class="fas fa-step-forward" />
            </template>
            <template v-slot:last-text>
              <i class="fas fa-step-backward" />
            </template>
          </b-pagination>

          <!-- end of table -->
        </div>
        <!-- end of col -->
      </div>
      <!-- end of row -->
    </div>
  </transition>
</template>

<script>
import controller from "../../../../Controllers/BadgesController";
import config from "../../../../config/config";
import Auth from "../../../../Apis/Auth";

export default {
  props: ["items", "editItem"],
  data() {
    return {
      bootstrapTable: {
        selected: [],
        selectMode: "multi",
        fields: [],
      },
      userType: Auth.USER.account_type,
      data: {},
      selectAll: false,
      
      currentPage: 1,
      select: [],
      page: 1,
      perPage: 5,
      search: "",
      from: 0,
      total: 0,
      totalRows: 0,
      to: 0,
      lastPage: 0,
      load: false,
      apiParams: {},
      params: {},
      recordIds: [],
      config,
    };
  },
  created() {
    this.bootstrapTable.fields = [
      { key: "checkbox", label: "", sortable: false },
      {
        key: "name",
        label: this.$i18n.t("badges.name"),
        sortable: true,
        sortDirection: "desc",
      },
      {
        key: "description",
        label: this.$i18n.t("badges.description"),
        sortable: true,
        sortDirection: "desc",
      },
      {
        key: "assignToStudent",
        label: this.$i18n.t("badges.assign_students"),
      },
      {
        key: "image",
        label: this.$i18n.t("badges.badge"),
        sortable: true,
        sortDirection: "desc",
      },
      { key: "edit", label: this.$i18n.t("site.action"), sortable: false },
    ];
    if (this.userType == "student") {
      this.bootstrapTable.fields = [
        {
          key: "name",
          label: this.$i18n.t("badges.name"),
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "description",
          label: this.$i18n.t("badges.description"),
          sortable: true,
          sortDirection: "desc",
        },

        {
          key: "image",
          label: this.$i18n.t("badges.badge"),
        },
      ];
    }
  },
  methods: {
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    }, //
    async dataProvider(ctx) {
      this.load = true;
      this.params = ctx;
      const data = await new controller().GetAll(this.apiParamsConverter());
      this.currentPage = data.current_page;
      this.perPage = data.per_page;
      this.totalRows = data.total;
      this.from = data.from;
      this.to = data.to;
      this.total = data.total;
      this.data = data.data;
      this.load = false;
      return data.data;
    },
    apiParamsConverter() {
      const apiParams = { per_page: this.perPage };
      if (this.params.currentPage >= 1) {
        apiParams.page = this.params.currentPage;
      }
      if (this.params.sortBy && this.params.sortBy.length > 0) {
        apiParams.sort = `${this.params.sortBy}|${
          this.params.sortDesc ? "desc" : "asc"
        }`;
      }
      if (this.params.filter && this.params.filter.length > 0) {
        // Optional
      }
      if (this.search !== "") {
        apiParams.search = this.search;
      }
      return apiParams;
    },
    changePageSize(perPage) {
      this.page = 1;
      this.perPage = perPage;
      this.dataProvider(this.params);
      this.$refs.table.refresh();
    },
    searchChange() {
      if (this.search.length == 0) {
        this.dataProvider(this.params);
        this.$refs.table.refresh();
      }
      if (this.search.length < 2) return;
      this.page = 1;
      this.dataProvider(this.params);
      this.$refs.table.refresh();
    },
    getImageUrl(image_path) {
      return config.serverUrl + image_path;
    },
    // selectItem(val, select) {
    //   if (select) {
    //     this.recordIds.push(val.item.id);
    //   } else {
    //     const index = this.recordIds.indexOf(val.item.id);
    //     if (index !== -1) {
    //       this.recordIds.splice(index, 1);
    //     }
    //   }
    // },
    selectItemAll(select) {
      this.recordIds = [];
      if (select) {
        console.log(this.data);
        this.data.forEach((element) => {
          this.recordIds.push(element.id);
        });
      }
    },
    deleteItem(data) {
      new controller().Delete(data.item.id, [], this.$refs.table);
    },
    multiDelete() {
      new controller().Delete(0, this.recordIds, this.$refs.table);
    },
  },
};
</script>
